import Button from '@anm/components/buttons/Button';
import CardModal from '@anm/components/modals/CardModal';
import useSwitchState from '@anm/hooks/useSwitchState';
import { FC } from 'react';
import styled from 'styled-components';

import { Price } from '../UpgradeToHightPlan';

export type HasCardProps = { onConfirm: () => void };

const ButtonWrapper = styled(Button)`
  margin-top: 25px;
`;
const TextBlock = styled.div``;
const Content = styled.div`
  padding: 20px;
  max-width: 380px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HasCard: FC<HasCardProps> = ({ onConfirm }) => {
  const [isOpen, open, close] = useSwitchState();
  const handleClick = () => {
    close();
    onConfirm();
  };

  return (
    <>
      {isOpen && (
        <CardModal onModalClose={close}>
          <Content>
            <TextBlock>
              You will be charged one time fee of <Price /> to upgrade to Business plan. Please confirm
            </TextBlock>
            <ButtonWrapper variant="light-blue" size="medium" onClick={handleClick}>
              Confirm
            </ButtonWrapper>
          </Content>
        </CardModal>
      )}
      <span>
        Upgrade to Business plan for one time fee of <Price />. Limited time offer!
        <br />
        <Button variant="link" size="medium" onClick={open}>
          Click here to upgrade.
        </Button>
      </span>
    </>
  );
};

export default HasCard;
